<template>
  <VaButton :icon="currentThemeIcon" preset="secondary" color="textPrimary" @click="toggleTheme" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { applyPreset, currentPresetName } = useColors()

const currentThemeIcon = computed(() => {
  return currentPresetName.value === 'dark' ? 'mso-light_mode' : 'mso-dark_mode'
})

const toggleTheme = () => {
  const newTheme = currentPresetName.value === 'dark' ? 'light' : 'dark'
  applyPreset(newTheme)
}
</script>
